import { SVGProps } from 'react'

export function VideoIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M21.15 6.17C20.74 5.95 19.88 5.72 18.71 6.54L17.24 7.58C17.13 4.47 15.78 3.25 12.5 3.25H6.5C3.08 3.25 1.75 4.58 1.75 8V16C1.75 18.3 3 20.75 6.5 20.75H12.5C15.78 20.75 17.13 19.53 17.24 16.42L18.71 17.46C19.33 17.9 19.87 18.04 20.3 18.04C20.67 18.04 20.96 17.93 21.15 17.83C21.56 17.62 22.25 17.05 22.25 15.62V8.38C22.25 6.95 21.56 6.38 21.15 6.17ZM11 11.38C9.97 11.38 9.12 10.54 9.12 9.5C9.12 8.46 9.97 7.62 11 7.62C12.03 7.62 12.88 8.46 12.88 9.5C12.88 10.54 12.03 11.38 11 11.38Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function FootballIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M8.65801 10.2223H7.34134C7.04801 10.2227 6.7621 10.1301 6.52478 9.95764C6.28747 9.78522 6.111 9.54194 6.02079 9.26282L5.61412 8.01115C5.52222 7.73189 5.52157 7.43063 5.61226 7.15098C5.70294 6.87132 5.88027 6.62778 6.11857 6.4556L7.18301 5.68448C7.41995 5.51147 7.70574 5.41823 7.99912 5.41823C8.2925 5.41823 8.57829 5.51147 8.81523 5.68448L9.88023 6.45782C10.1186 6.62994 10.296 6.87348 10.3867 7.15316C10.4774 7.43283 10.4767 7.73412 10.3847 8.01337L9.97856 9.26504C9.88752 9.54347 9.71077 9.78598 9.47359 9.9579C9.23641 10.1298 8.95095 10.2224 8.65801 10.2223ZM14.6663 8.00004C14.6663 9.31858 14.2753 10.6075 13.5428 11.7038C12.8103 12.8002 11.7691 13.6547 10.5509 14.1592C9.33272 14.6638 7.99228 14.7958 6.69907 14.5386C5.40587 14.2814 4.21798 13.6464 3.28563 12.7141C2.35328 11.7817 1.71834 10.5938 1.46111 9.30064C1.20387 8.00743 1.3359 6.66699 1.84048 5.44882C2.34506 4.23064 3.19955 3.18945 4.29587 2.45691C5.3922 1.72437 6.68113 1.33337 7.99968 1.33337C9.7672 1.33529 11.4618 2.03828 12.7116 3.28811C13.9614 4.53793 14.6644 6.23252 14.6663 8.00004Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function AmericanFootballIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M11.1665 2C6.11241 2 2 6.1125 2 11.1667C2 11.5817 2.06667 12.255 2.1725 13.0617C2.36916 14.6842 2.70498 16.4733 2.97998 18.0875C3.2633 19.6767 4.40828 20.9342 5.96658 21.3675C7.06238 21.6733 8.49068 22 11.5831 22C12.0431 22 12.4164 21.6275 12.4164 21.1667C12.4164 20.7058 12.0431 20.3333 11.5831 20.3333C10.8573 20.3333 10.2323 20.3142 9.68732 20.2825L9.09067 16.1667H11.9998C12.4598 16.1667 12.8331 15.7942 12.8331 15.3333C12.8331 14.8725 12.4598 14.5 11.9998 14.5H4.12078C3.96829 13.9783 3.89912 13.3992 3.83246 12.9042C3.77579 12.0883 3.91079 11.4633 4.23828 11.0192C5.02243 9.95417 7.09405 9.5 11.1656 9.5C15.8647 9.5 18.1946 10.1075 18.7213 11.4675C18.8663 11.8417 19.2571 12.0542 19.6513 11.9858C20.0454 11.9117 20.3312 11.5675 20.3312 11.1667C20.3329 6.1125 16.2205 2 11.1665 2Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function VolleyballIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M22 12.1308C21.9801 13.5899 21.6387 15.0266 20.9999 16.3385C20.9386 16.3379 20.8773 16.3443 20.8174 16.3577C19.3025 16.8032 17.7293 17.0193 16.1504 16.9987C14.4507 17.0463 12.7544 16.8211 11.1259 16.3319C10.9322 16.2662 10.758 16.1534 10.6188 16.0035C10.4797 15.8537 10.38 15.6715 10.3288 15.4735C10.2777 15.2755 10.2766 15.0679 10.3256 14.8694C10.3747 14.6709 10.4725 14.4877 10.61 14.3364C10.8906 14.0241 11.1907 13.7298 11.5084 13.4553C11.6723 13.3233 11.8677 13.2361 12.0754 13.2021C12.283 13.168 12.496 13.1884 12.6935 13.2611C13.759 13.6166 14.8747 13.7984 15.9979 13.7996C18.1101 13.7778 20.1796 13.2024 22 12.1308Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function TennisIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M12.9362 2.0092C15.2654 2.22383 17.4461 3.24681 19.1001 4.90078C20.754 6.55475 21.777 8.73539 21.9916 11.0646C20.7599 11.2481 19.5024 11.1407 18.3196 10.751C17.1368 10.3614 16.0617 9.70027 15.1802 8.82062C14.3004 7.9393 13.6391 6.86418 13.2494 5.68137C12.8598 4.49855 12.7525 3.24092 12.9362 2.0092Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function BasketballIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M15.5433 7.27833C14.3113 5.85647 13.6436 4.03208 13.6667 2.15083C15.4319 2.44741 17.0846 3.21431 18.4508 4.37083L15.5433 7.27833ZM8.46 14.3617L10.8217 12L4.37083 5.54917C2.8397 7.34974 1.99929 9.63643 2 12H2.26917C4.54626 12.0333 6.73824 12.8707 8.4575 14.3642L8.46 14.3617Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function HockeyIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M2.0425 8.49333C2.46833 4.86333 6.7675 2 12 2C17.2325 2 21.5317 4.86333 21.9575 8.49333C21.5317 11.8508 17.2325 14.5 12 14.5C6.7675 14.5 2.46833 11.8508 2.0425 8.49333ZM12 16.1667C7.75 16.1667 4.04083 14.555 2 12.1592V14.9167C2 18.8225 6.48583 22 12 22C17.5142 22 22 18.8225 22 14.9167V12.1592C19.9592 14.555 16.25 16.1667 12 16.1667Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function BaseballIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M22 19.0695C22 19.647 21.829 20.2116 21.5087 20.6919C21.1884 21.1721 20.7331 21.5464 20.2004 21.7675C19.6677 21.9885 19.0816 22.0463 18.5161 21.9336C17.9506 21.821 17.4312 21.5428 17.0235 21.1344C16.6158 20.726 16.3381 20.2057 16.2257 19.6392C16.1132 19.0727 16.1709 18.4855 16.3916 17.9519C16.6122 17.4183 16.9858 16.9622 17.4652 16.6413C17.9446 16.3204 18.5083 16.1492 19.0848 16.1492C19.858 16.1492 20.5995 16.4568 21.1462 17.0045C21.6929 17.5522 22 18.295 22 19.0695Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function BoxingIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M3.00027 7.8975C2.99292 7.12635 3.13558 6.36134 3.42002 5.64664C3.70446 4.93194 4.12504 4.28168 4.65749 3.73339C5.18995 3.1851 5.82373 2.74964 6.52228 2.45213C7.22082 2.15462 7.9703 2.00095 8.72746 2L12.8183 2C14.055 2.00202 15.258 2.41116 16.2478 3.1664C17.2376 3.92164 17.9612 4.98252 18.3107 6.19083C17.2705 6.25033 16.292 6.71234 15.5752 7.48237C14.8584 8.25239 14.4576 9.27224 14.4546 10.3333V13.6667C14.4546 13.8877 14.5408 14.0996 14.6943 14.2559C14.8477 14.4122 15.0558 14.5 15.2728 14.5C15.4898 14.5 15.6979 14.4122 15.8513 14.2559C16.0048 14.0996 16.091 13.8877 16.091 13.6667V10.475C16.0768 9.81669 16.3089 9.17752 16.7402 8.68701C17.1715 8.1965 17.7698 7.89133 18.4138 7.83333C18.747 7.81509 19.0804 7.86626 19.3936 7.9837C19.7067 8.10114 19.9931 8.2824 20.2352 8.51639C20.4772 8.75038 20.6699 9.03218 20.8014 9.34459C20.9329 9.65699 21.0005 9.99343 21 10.3333V12.8958C20.9685 13.8735 20.7115 14.8299 20.2499 15.6876C19.7882 16.5454 19.1348 17.2804 18.3426 17.8333H4.49507L4.18662 17.3842C3.41431 16.2632 3.00005 14.9269 3.00027 13.5575V10.7033C3.49555 11.0033 4.06041 11.1632 4.63661 11.1667H12.0001C12.2171 11.1667 12.4252 11.0789 12.5787 10.9226C12.7321 10.7663 12.8183 10.5543 12.8183 10.3333C12.8183 10.1123 12.7321 9.90036 12.5787 9.74408C12.4252 9.5878 12.2171 9.5 12.0001 9.5H4.63661C4.21228 9.5039 3.80335 9.33833 3.49746 9.03877C3.19158 8.73921 3.01309 8.32951 3.00027 7.8975Z'
				fill='currentColor'
			/>
		</svg>
	)
}
